<template>
  <user-header></user-header>
  <breadcrumb :title="title" :text="text" :text1="text1" />
  <user-tabset></user-tabset>
  <div class="content court-bg">
    <div class="container">
      <!-- Sort By -->
      <div class="row">
        <div class="col-lg-12">
          <div class="sortby-section court-sortby-section">
            <div class="sorting-info">
              <div class="row d-flex align-items-center">
                <div class="col-xl-6 col-lg-6 col-sm-12 col-12">
                  <div class="coach-court-list">
                    <ul class="nav">
                      <li>
                        <router-link to="/user/user-invoice">Courts</router-link>
                      </li>
                      <li><router-link to="/user/user-coaches">Coaches</router-link></li>
                    </ul>
                  </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-sm-12 col-12">
                  <div class="sortby-filter-group court-sortby">
                    <div class="sortbyset week-bg">
                      <div class="sorting-select">
                        <vue-select
                          :options="ThisWeekOne"
                          id="thisweekone"
                          placeholder="This Week"
                        />
                      </div>
                    </div>
                    <div class="sortbyset">
                      <span class="sortbytitle">Sort By</span>
                      <div class="sorting-select">
                        <vue-select
                          :options="RelevanceOne"
                          id="relevanceone"
                          placeholder="Relevance"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Sort By -->

      <div class="row">
        <div class="col-sm-12">
          <div class="court-tab-content">
            <div class="card card-tableset">
              <div class="card-body">
                <div class="coache-head-blk">
                  <div class="row align-items-center">
                    <div class="col-md-5">
                      <div class="court-table-head">
                        <h4>Invoices</h4>
                        <p>Access recent invoices related to court bookings</p>
                      </div>
                    </div>
                    <div class="col-md-7">
                      <div class="table-search-top invoice-search-top">
                        <div id="tablefilter">
                          <div class="dataTables_filter">
                            <label> 
                                <input type="search" class="form-control form-control-sm" placeholder="Search" aria-controls="DataTables_Table_0">
                            </label>
                          </div>
                        </div>
                        <div class="request-coach-list select-filter">
                          <div class="sortby-filter-group court-sortby">
                            <div class="sortbyset m-0">
                              <div class="sorting-select">
                                <vue-select
                                  :options="Invoice"
                                  id="invoice"
                                  placeholder="All Invoices"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="table-responsive table-datatble">
                  <a-table class="table datatable" :columns="columns" :data-source="data">
                    <template #bodyCell="{ column, record }">
                      <template v-if="column.key === 'ID'">
                        <div>
                          <router-link to="/user/invoice" class="text-primary">{{
                            record.ID
                          }}</router-link>
                        </div>
                      </template>
                      <template v-else-if="column.key === 'CourtName'">
                        <h2 class="table-avatar">
                          <a href="javascript:void(0);" class="avatar avatar-sm flex-shrink-0"
                            ><img
                              class="avatar-img"
                              :src="require(`@/assets/img/booking/${record.Image}`)"
                              alt="User Image"
                          /></a>
                          <span class="table-head-name flex-grow-1">
                            <a href="javascript:void(0);">{{ record.CourtName }}</a>
                            <span>{{ record.Court }}</span>
                          </span>
                        </h2>
                      </template>
                      <template v-else-if="column.key === 'Date'">
                        <div class="table-date-time">
                          <h4>
                            {{ record.Date }}<span>{{ record.Time }}</span>
                          </h4>
                        </div>
                      </template>
                      <template v-else-if="column.key === 'Payment'">
                        <div>
                          <span class="pay-dark fs-16">{{ record.Payment }}</span>
                        </div>
                      </template>
                      <template v-else-if="column.key === 'Status'">
                        <span :class="record.Class"
                          ><i class="feather-check-square me-1"></i
                          >{{ record.Status }}</span
                        >
                      </template>
                      <template v-else-if="column.key === 'Download'">
                        <td class="text-pink view-detail-pink">
                          <a href="javascript:;"
                            ><i class="feather-download"></i>Download</a
                          >
                        </td>
                      </template>
                      <template v-else-if="column.key === 'action'">
                        <td class="text-end">
                          <div class="dropdown dropdown-action table-drop-action">
                            <a
                              href="javascript:void(0);"
                              class="action-icon dropdown-toggle"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              ><i class="fas fa-ellipsis-h"></i
                            ></a>
                            <div class="dropdown-menu dropdown-menu-end">
                              <a class="dropdown-item" href="javascript:void(0);"
                                ><i class="feather-briefcase"></i>Refund</a
                              >
                              <a class="dropdown-item" href="javascript:void(0);"
                                ><i class="feather-trash"></i>Delete</a
                              >
                            </div>
                          </div>
                        </td>
                      </template>
                    </template>
                  </a-table>
                </div>
              </div>
            </div>
            <div class="tab-footer">
              <div class="row">
                <div class="col-md-6">
                  <div id="tablelength">
                    <div class="dataTables_length" id="DataTables_Table_0_length">
                      <label>Show
                        <select class="custom-select custom-select-sm form-control form-control-sm">
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="-1">All</option>
                        </select>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div id="tablepage">
                    <div class="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate">
                      <ul class="pagination">
                        <li class="paginate_button page-item previous disabled" id="DataTables_Table_0_previous"><a
                            href="javascript:void(0);" aria-controls="DataTables_Table_0" data-dt-idx="0" tabindex="0"
                            class="page-link"><i class="feather-chevrons-left"></i></a></li>
                        <li class="paginate_button page-item active"><a href="javascript:void(0);"
                            aria-controls="DataTables_Table_0" data-dt-idx="1" tabindex="0" class="page-link">1</a></li>
                        <li class="paginate_button page-item next disabled" id="DataTables_Table_0_next"><a
                            href="javascript:void(0);" aria-controls="DataTables_Table_0" data-dt-idx="2" tabindex="0"
                            class="page-link"><i class="feather-chevrons-right"></i></a></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <layout-footer></layout-footer>
</template>
<script>
const columns = [
  {
    title: "ID",
    dataIndex: "ID",
    key: "ID",
    sorter: {
      compare: (a, b) => {
        a = a.ID.toLowerCase();
        b = b.ID.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Court Name",
    dataIndex: "CourtName",
    key: "CourtName",
    sorter: {
      compare: (a, b) => {
        a = a.CourtName.toLowerCase();
        b = b.CourtName.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Date & Time",
    dataIndex: "Date",
    key: "Date",
    sorter: {
      compare: (a, b) => {
        a = a.Date.toLowerCase();
        b = b.Date.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Payment",
    dataIndex: "Payment",
    key: "Payment",
    sorter: {
      compare: (a, b) => {
        a = a.Payment.toLowerCase();
        b = b.Payment.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Paid On",
    dataIndex: "PaidOn",
    key: "PaidOn",
    sorter: {
      compare: (a, b) => {
        a = a.PaidOn.toLowerCase();
        b = b.PaidOn.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Status",
    dataIndex: "Status",
    key: "Status",
    sorter: {
      compare: (a, b) => {
        a = a.Status.toLowerCase();
        b = b.Status.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Download",
    dataIndex: "Download",
    key: "Download",
    sorter: {
      compare: (a, b) => {
        a = a.Download.toLowerCase();
        b = b.Download.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "",
    key: "action",
    sorter: true,
  },
];
const data = [
  {
    ID: "#CO14",
    CourtName: "Leap Sports Academy",
    Court: "Court 1",
    Date: "Mon, Jul 12",
    Time: "06:00 PM - 08:00 PM",
    Payment: "$150",
    PaidOn: "Mon, Jul 12",
    Status: "Paid",
    Class: "badge bg-success",
    Image: "booking-01.jpg",
  },
  {
    ID: "#CO15",
    CourtName: "Wing Sports Academy",
    Court: "Court 1",
    Date: "Mon, Jul 13",
    Time: "07:00 PM - 09:00 PM",
    Payment: "$200",
    PaidOn: "Mon, Jul 13",
    Status: "Pending",
    Class: "badge bg-info",
    Image: "booking-02.jpg",
  },
  {
    ID: "#CO16",
    CourtName: "Feather Badminton",
    Court: "Court 1",
    Date: "Mon, Jul 14",
    Time: "01:00 PM - 02:00 PM",
    Payment: "$150",
    PaidOn: "Mon, Jul 14",
    Status: "Failed",
    Class: "badge bg-danger",
    Image: "booking-03.jpg",
  },
  {
    ID: "#CO17",
    CourtName: "Bwing Sports Academy",
    Court: "Court 1",
    Date: "Mon, Jul 15",
    Time: "01:00 PM - 04:00 PM",
    Payment: "$90",
    PaidOn: "Mon, Jul 15",
    Status: "Paid",
    Class: "badge bg-success",
    Image: "booking-04.jpg",
  },
  {
    ID: "#CO18",
    CourtName: "Bwing Sports Academy",
    Court: "Court 1",
    Date: "Mon, Jul 16",
    Time: "03:00 PM - 05:00 PM",
    Payment: "$180",
    PaidOn: "Mon, Jul 16",
    Status: "Paid",
    Class: "badge bg-success",
    Image: "booking-05.jpg",
  },
];
export default {
  data() {
    return {
      title: "Invoice",
      text: "Home",
      text1: "Invoice",
      data,
      columns,
      ThisWeekOne: ["This Week", "One Day"],
      RelevanceOne: ["Relevance", "Price"],
      Invoice: ["All Invoices", "Completed", "Inprogress"],
    };
  },
};
</script>
